import { styled } from '@mui/material/styles';
import { Typography, Paper } from '@mui/material';

const PREFIX = 'InsuranceFormInstructions';

const classes = {
  container: `${PREFIX}-container`,
};

const Root = styled(Paper)(({ theme }) => ({
  [`&.${classes.container}`]: {
    backgroundColor: 'rgba(1, 16, 18, 0.04)',
    padding: theme.spacing(2),
    width: 564,
    marginLeft: 12,
    marginRight: 'auto',
    overflowY: 'auto',
  },
}));

export default function InsuranceFormInstructions() {
  return (
    <Root className={classes.container}>
      <Typography mt={2} mb={2} variant="h4">
        Support for this page
      </Typography>
      <Typography variant="h6">
        As part of our agreement, we need to be aware of the insurance coverage
        that your business carries. Please provide us with the insurance
        coverage information for your Commercial and Auto Liability that can be
        found on the Certificate of Insurance (COI).
      </Typography>
    </Root>
  );
}
